import {HTTP_INTERCEPTORS} from "@angular/common/http";

import {AuthIntercepterService} from "./auth-intercepter.service";

/*
providers: [
 httpInterceptorProviders
]
*/

export const httpInterceptorProviders = [
  {provide: HTTP_INTERCEPTORS, useClass: AuthIntercepterService, multi: true}
];
